import React, { Component } from 'react';
import PageTitle from './PageTitle';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

export default class Clients extends Component {

    constructor() {
        super();
        this.state = { clients: [] };
    }

    componentWillMount() {

        const requestInfo = {
            method: 'GET',
            headers: new Headers({
                'Content-type': 'application/json',
                'Access-Control-Allow-Origin': '*'
            })
        };

        fetch('http://api.fcsistema.com.br/api-website-fc/clients', requestInfo)
            .then(response => response.json())
            .then(data => {
                console.log(data);
                this.setState({ clients: data });
            })
            .catch(error => {
                this.setState({ msg: error.message });
            });
    }

    render() {
        return (
            <div>
                <PageTitle title="Clientes" last="Home" lastLink="/" />
                <section className="section-padding">
                    <div className="container">
                        <div className="text-center mb-80">
                            <h2 className="section-title text-uppercase">Nossos clientes</h2>
                            <p className="section-sub">
                            Em sua trajetória, a FC Sistemas se orgulha por ter conquistado grandes clientes e parceiros de variadas áreas de atuação.
                            Em nossa relação com clientes, não visamos somente nosso compromisso com o negócio do cliente, mas sim com os resultados a serem alcançados.
                            Nosso maior objetivo é manter nossos clientes satisfeitos e buscar criar e manter relacionamentos de longo prazo, baseado na integridade e comprometimento, sempre atendendo suas necessidades.</p>
                        </div>

                        <div className="clients-grid grid-gutter">
                            <div className="row">
                            <ReactCSSTransitionGroup
                                transitionName="timeline"
                                transitionEnterTimeout={500}
                                transitionLeaveTimeout={300}>
                                        { 
                                            this.state.clients.map(client => {
                                                return (
                                                    <div key={client.id} className="col-md-3 col-sm-6">
                                                        <div className="border-box">
                                                            <a>
                                                                <img src={client.imagemPath} alt="clients" title={client.nome} />
                                                            </a>
                                                        </div>
                                                    </div>
                                                );
                                            })
                                        }
                                </ReactCSSTransitionGroup>
                            </div>
                        </div>

                    </div>
                </section>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Clients.js